import Vue, { CreateElement } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: '4N9jpgs11U2MNBuScOqXCix9SWCOHllW'//颍上公交
	//   Yw6v2WPTd0ZjtYOQR5dNW6vqoBNqXw6W   中科爱电
});

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h : CreateElement) => h(App)
}).$mount('#app');